var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeSection32(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    height: 86.233,
    viewBox: "0 0 140 86.233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7127",
    "data-name": "Rectangle 7127",
    width: 140,
    height: 86.233,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9204",
    "data-name": "Group 9204",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8997",
    "data-name": "Group 8997",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13366",
    "data-name": "Path 13366",
    d: "M63.65,30.438a8.834,8.834,0,0,1-1.592-.144L44.565,27.113a1.284,1.284,0,0,1,.462-2.527l17.49,3.185a6.493,6.493,0,0,0,7.416-4.763,6.462,6.462,0,0,0-4.665-7.854L45.716,10.177a6.186,6.186,0,0,0-3.377.094l-.263.084L14.738,19.011a7.158,7.158,0,0,0-4.662,8.981,1.283,1.283,0,0,1-2.446.773,9.72,9.72,0,0,1,6.335-12.2l27.6-8.74a8.8,8.8,0,0,1,4.781-.14L65.9,12.669a9.025,9.025,0,0,1,6.52,10.973,9.074,9.074,0,0,1-8.771,6.8",
    transform: "translate(17.928 18.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13367",
    "data-name": "Path 13367",
    d: "M20.156,47.722a1.276,1.276,0,0,1-.259-.028,1.291,1.291,0,0,1-.823-.564L3.4,22.718a1.29,1.29,0,0,1,.382-1.771l14.469-9.425a1.283,1.283,0,1,1,1.4,2.149L6.254,22.4,20.527,44.638l20.2-13.622a1.284,1.284,0,1,1,1.438,2.128L20.873,47.5a1.284,1.284,0,0,1-.718.22",
    transform: "translate(7.998 28.282)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13368",
    "data-name": "Path 13368",
    d: "M21.458,53.223a1.185,1.185,0,0,1-.273-.028,1.306,1.306,0,0,1-.808-.56L.2,21.212a1.287,1.287,0,0,1,.389-1.775l9.394-6.03a1.284,1.284,0,0,1,1.774.385L31.93,45.215a1.283,1.283,0,0,1-.385,1.775l-9.394,6.03a1.252,1.252,0,0,1-.693.2M3.058,20.9,21.843,50.168l7.234-4.644L10.293,16.26Z",
    transform: "translate(0.001 33.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13369",
    "data-name": "Path 13369",
    d: "M54.522,43.02a9.8,9.8,0,0,1-2.069-.22,10.273,10.273,0,0,1-1.4-.42L11.85,31.813a1.283,1.283,0,1,1,.669-2.478L51.781,39.919a.841.841,0,0,1,.133.042A7.443,7.443,0,0,0,53,40.29a7.245,7.245,0,0,0,3.266-.052L99.889,22.591l.091-.031a4.686,4.686,0,1,0-2.849-8.929L55.393,25.674a1.3,1.3,0,0,1-.823-.039L37.54,18.968a1.283,1.283,0,1,1,.934-2.39L55.1,23.084,96.385,11.174a7.253,7.253,0,0,1,4.424,13.814L57.15,42.649A1.334,1.334,0,0,1,57,42.7a9.7,9.7,0,0,1-2.475.318",
    transform: "translate(27.245 27.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13370",
    "data-name": "Path 13370",
    d: "M46.156,14.785H26.108a1.285,1.285,0,0,1,0-2.569H46.156a1.285,1.285,0,1,1,0,2.569",
    transform: "translate(62.068 30.541)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13371",
    "data-name": "Path 13371",
    d: "M79.857,45.325a1.285,1.285,0,1,1,0-2.569A6.059,6.059,0,0,0,85.912,36.7V8.621a6.059,6.059,0,0,0-6.055-6.052H29.23a6.059,6.059,0,0,0-6.055,6.052V29.89a1.283,1.283,0,1,1-2.565,0V8.621A8.631,8.631,0,0,1,29.23,0H79.857a8.631,8.631,0,0,1,8.62,8.621V36.7a8.631,8.631,0,0,1-8.62,8.62",
    transform: "translate(51.522 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13372",
    "data-name": "Path 13372",
    d: "M34.607,8.9H23.337a1.285,1.285,0,0,1,0-2.569h11.27a1.285,1.285,0,1,1,0,2.569",
    transform: "translate(55.132 15.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13373",
    "data-name": "Path 13373",
    d: "M38.716,8.9H27.443a1.285,1.285,0,0,1,0-2.569H38.716a1.285,1.285,0,1,1,0,2.569",
    transform: "translate(65.405 15.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13374",
    "data-name": "Path 13374",
    d: "M42.828,8.9H31.554a1.285,1.285,0,0,1,0-2.569H42.828a1.285,1.285,0,0,1,0,2.569",
    transform: "translate(75.675 15.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13375",
    "data-name": "Path 13375",
    d: "M46.934,8.9H35.665a1.285,1.285,0,1,1,0-2.569h11.27a1.285,1.285,0,0,1,0,2.569",
    transform: "translate(85.95 15.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13376",
    "data-name": "Path 13376",
    d: "M37.967,12.342H26.035a1.285,1.285,0,1,1,0-2.569H37.967a1.285,1.285,0,0,1,0,2.569",
    transform: "translate(61.877 24.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13377",
    "data-name": "Path 13377",
    d: "M39.276,12.342H31.114a1.285,1.285,0,1,1,0-2.569h8.162a1.285,1.285,0,0,1,0,2.569",
    transform: "translate(74.565 24.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13378",
    "data-name": "Path 13378",
    d: "M48.989,7.51H23.334a1.279,1.279,0,0,1-1.281-1.281v-3.5a1.28,1.28,0,0,1,1.281-1.285H48.989a1.283,1.283,0,0,1,1.285,1.285v3.5A1.282,1.282,0,0,1,48.989,7.51M24.618,4.944H47.7V4.013H24.618Z",
    transform: "translate(55.132 3.611)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSection32);
export default __webpack_public_path__ + "static/media/home_section_3_2.5776828ebcbad4dc581cbeb2f4d91027.svg";
export { ForwardRef as ReactComponent };